export default {
  name: 'NegocioMixin',
  inject: {
    erplayout: {
      default () {
        console.error('Main needs to be child of ErpLayout')
      }
    }
  },
  mounted() {
    window.setTimeout(() => {
      this.erplayout.erpheader.setMenuModuleToggle(true)
    }, 10)
    document.body.classList.add('financial-module-body')
    this.erplayout.erpheader.menu.setActiveMenu('negocio')
  },
  destroyed() {
    document.body.classList.remove('negocio-module-body')
    // document.querySelector('.u-erp-layout-container').classList.remove('bg-white')
  },
  beforeDestroy() {
    this.erplayout.erpheader.setMenuModuleToggle(false)
  }
}
